// extracted by mini-css-extract-plugin
export default {"container":"xX07Mp","divider":"xYMaV2","stack":"_0ZuMIU"};